module.exports = __webpack_public_path__ + "img/logo_deansel.0a37d3fe.jpg";